import { Link } from "react-router-dom";
import { Car } from "lucide-react";
import { fmtDate } from "../lib/api";
import { useApi, Loading, ErrorNote, Empty } from "./kit";

const STATE = {
  valid: ["Valid", "bg-emerald-100 text-emerald-800"],
  valid_no_expiry: ["Valid (no expiry)", "bg-emerald-100 text-emerald-800"],
  expiring: ["Expiring soon", "bg-amber-100 text-amber-900"],
  expired: ["Expired", "bg-rose-100 text-rose-800"],
  awaiting_review: ["Waiting for review", "bg-sky-100 text-sky-800"],
  expiry_unknown: ["On file, expiry unknown", "bg-slate-100 text-slate-700"],
  none: ["None on file", "bg-slate-100 text-slate-500"],
};
const ORDER = ["expired", "expiring", "awaiting_review", "expiry_unknown", "valid", "valid_no_expiry", "none"];

export function DriversTab({ all }) {
  const { data, loading, error } = useApi(`/team/drivers?all=${all}`);
  if (loading) return <Loading />;
  if (error) return <ErrorNote error={error} />;
  if (!data.length) return <Empty testid="drivers-empty">Nobody on your team yet.</Empty>;
  const rows = [...data].sort((a, b) => ORDER.indexOf(a.state) - ORDER.indexOf(b.state) || a.name.localeCompare(b.name));
  const ok = data.filter((r) => ["valid", "valid_no_expiry", "expiring"].includes(r.state)).length;
  return (
    <div className="space-y-4" data-testid="drivers-tab">
      <p className="flex items-center gap-2 text-sm"><Car className="h-5 w-5" /><span><b data-testid="drivers-valid-count">{ok}</b> of {data.length} can drive today with a valid licence on file. Expired licences show first.</span></p>
      <ul className="grid gap-2">{rows.map((r) => { const [l, cls] = STATE[r.state] || STATE.none; return (
        <li key={r.user_id}><Link to={`/team/${r.user_id}`} data-testid={`driver-row-${r.user_id}`}
          className="flex items-start gap-3 rounded-xl border bg-white p-3 transition-colors hover:border-[color:var(--ink)]">
          <span className="min-w-0 flex-1"><span className="block font-semibold">{r.name}</span>
            <span className="block text-xs text-muted-foreground">{[r.department, r.licence_class && <span key="c" data-testid={`driver-class-${r.user_id}`}>{r.licence_class}</span>,
              r.expiry_date && `${r.state === "expired" ? "Expired" : "Expires"} ${fmtDate(r.expiry_date)}`].filter(Boolean).map((x, i) => <span key={i}>{i > 0 && " · "}{x}</span>)}</span></span>
          <span className={`shrink-0 rounded-full px-2.5 py-1 text-xs font-semibold ${cls}`} data-testid={`driver-state-${r.user_id}`}>{l}</span>
        </Link></li>); })}</ul>
      <p className="text-xs text-muted-foreground">Licences are uploaded under My Records → Certificates & licences, with the type "Driver's licence". Drivers and their manager are reminded 60 and 30 days before expiry, weekly after that, and on the day it expires.</p>
    </div>
  );
}
